import React from 'react'
import { Button, Form, Input, Select } from 'antd'
import ProjectSelector from '../../ProjectSelector'
import StockroomSelector from '../../StockroomSelector'
import { DEFAULT_EQUIPMENT_STATUSES, EQUIPMENT_WORK_FLOW } from '../constants'
import EmployeeSelector from '../../employee/EmployeeSelector'

const STATUS_OPTIONS = Object.entries(EQUIPMENT_WORK_FLOW).map(([key, { caption }]) => ({ label: caption, value: key }))

const EquipmentsFilterPanel = ({ onSearch }) => {
  const [form] = Form.useForm()

  const onFormSubmit = ({ project, stockroom, name, current_status, create_user }) => {
    let filter = { project, stockroom, name, current_status, create_user }
    onSearch(filter)
  }

  const onClear = () => {
    form.resetFields()
    onSearch({})
  }

  return (
    <Form
      form={form}
      initialValues={{ current_status: DEFAULT_EQUIPMENT_STATUSES }}
      layout="vertical"
      style={{ display: 'flex', paddingRight: 15 }}
      onFinish={onFormSubmit}
    >
      <Form.Item style={{ width: 300, maxWidth: 300 }} label="Проект" name="project">
        <ProjectSelector userFilter={true} />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15, width: 300, maxWidth: 300 }} label="Склад" name="stockroom">
        <StockroomSelector />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15, width: 300, maxWidth: 300 }} label="Наименование" name="name">
        <Input allowClear />
      </Form.Item>
      <Form.Item
        style={{ marginLeft: 15, width: 200, maxWidth: 250 }}
        label="Пользователь создавший"
        name="create_user"
      >
        <EmployeeSelector />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15, width: 400, maxWidth: 600 }} label="Статусы заявки" name="current_status">
        <Select mode="multiple" allowClear options={STATUS_OPTIONS} dropdownMatchSelectWidth={false} />
      </Form.Item>
      <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
        <Button onClick={() => form.submit()}>Применить</Button>
      </Form.Item>
      <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
        <Button type="dashed" onClick={onClear}>
          Очистить
        </Button>
      </Form.Item>
    </Form>
  )
}

export default EquipmentsFilterPanel
